import React from "react";


// Libraries
// Import Swiper React components
import SwiperCore, { Navigation, EffectFade, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/effect-fade/effect-fade.scss';


// Utils
import Game from "./game";
import { useRef } from "react";
import { useCallback } from "react";


SwiperCore.use([Navigation, EffectFade, Autoplay]);

const CarouselGames = ({ carousel, desktop }) => {

    const sliderRef = useRef(null);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);


    return (
        <>
            {carousel.length > 0 &&
                <div class="c-carouselActus--externalbutton">
                    <div className="c-carouselActus">
                        <Swiper className="c-carouselActus_items"
                            //navigation={true}
                            slidesPerView="auto"
                            spaceBetween={desktop ? 20 : 10}
                            watchSlidesVisibility={true}
                            allowTouchMove={((desktop && carousel.length > 3) || (!desktop && carousel.length > 1)) ? true : false}
                            loop={((desktop && carousel.length > 3) || (!desktop && carousel.length > 1)) ? true : false}
                            pagination={((desktop && carousel.length > 3) || (!desktop && carousel.length > 1)) ? { clickable: true } : false}
                            ref={sliderRef}
                        >

                            {
                                carousel.map((item, key) => {
                                    return (
                                        <SwiperSlide key={key} className="c-carouselActus_item">
                                            <Game {...item} />
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </div>
                    <div className="swiper-button-prev" onClick={handlePrev}></div>
                    <div className="swiper-button-next" onClick={handleNext}></div>
                </div>
            }
        </>
    )
};

export default CarouselGames;